import App from './App';
import AppContainer from './App.container';

export default AppContainer(App);
